import React from 'react';
import { Form, Input, Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { TransferRequest } from '../../../../models'

let QueryForm = (props) => {
    const { form  } = props;
    const { getFieldDecorator } = form;
    const validations = TransferRequest.validations;

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
			if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };


    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: props.transferRequest.id,
                rules: validations.uuid
            })(<Input autoComplete='off' hidden />)}
            <Form.Item label="Comments">
                {getFieldDecorator("comment", {
                    rules: [
                        { required: true, message: "Please enter a comment" },
                        { pattern: /^(?! +$)[A-Za-z0-9.,*/()@#$%^&*!-_ ]+$/, message: "Please enter a valid comment." },
                        { max: 255, message: "Can be of maximum 255 characters" },
                    ]
                })((<TextArea ows={1} />))}
            </Form.Item>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.isSaving}>Submit </Button>
            </div>
        </Form>
    )
};

QueryForm = Form.create()(QueryForm);
export { QueryForm };